import React, { useMemo } from 'react';

import { useUsers, useCompanies } from '@adsk/alloy-provider';
import Avatar from '@adsk/alloy-react-avatar';
import HighlightText from '@adsk/alloy-react-highlight-text';
import { BuildingIcon } from '@adsk/alloy-react-icon';
import { useLocale } from '@adsk/alloy-react-locale';
import theme from '@adsk/alloy-react-theme';
import { OverflowTooltip } from '@adsk/alloy-react-tooltip';

import { MentionData } from '../../consts';

export const MentionCompanySuggestion = ({
  suggestion,
  searchValue,
}: {
  suggestion: MentionData;
  searchValue?: string;
}) => {
  const { T } = useLocale(({ locale }) => require(`../../i18n/${locale}.json`));
  const users = useUsers();
  const companies = useCompanies();
  const currentCompany = useMemo(
    () =>
      companies.data.find((company) => company.memberGroupId === suggestion.id),
    [companies.data, suggestion.id],
  );
  const userWithCompanyCount = useMemo(
    () =>
      users.data.filter((user) => user.companyId === currentCompany?.id).length,
    [currentCompany?.id, users.data],
  );

  return (
    <>
      <Avatar
        style={{
          color: theme.colors.charcoal500,
          backgroundColor: theme.colors.charcoal100,
        }}
      >
        <BuildingIcon />
      </Avatar>
      <span style={{ marginLeft: 10 }}>
        <div
          style={{
            width: '100%',
            display: 'table',
            tableLayout: 'fixed',
          }}
        >
          <OverflowTooltip content={currentCompany?.name || suggestion.name}>
            <HighlightText
              matched={searchValue}
              text={
                currentCompany?.name ||
                suggestion.name ||
                T.translate('FORMER_COMPANY')?.toString()
              }
              style={{
                ...theme.typography.bodyMedium,
                color: theme.colors.charcoal900,
              }}
              highlightStyle={{
                ...theme.typography.bodyMediumBold,
                backgroundColor: 'transparent',
              }}
            />
          </OverflowTooltip>
          <div
            style={{
              ...theme.typography.bodySmall,
              color: theme.colors.charcoal700,
            }}
          >
            <OverflowTooltip
              content={T.translate('USERS_COUNT', {
                context: userWithCompanyCount,
              })}
            >
              {T.translate('USERS_COUNT', { context: userWithCompanyCount })}
            </OverflowTooltip>
          </div>
        </div>
      </span>
    </>
  );
};
